import * as THREE from 'three';
import Figure from './Figure';

const perspective = 800;

export default class Scene {
  constructor() {
    this.container = document.querySelector('#scene');
    this.scene = new THREE.Scene();

    this.renderer = new THREE.WebGLRenderer({
      canvas: this.container,
      alpha: true
    });

    this.scrollDistance = 0;
    this.scrollFactor = {
      value: 0
    };

    this.fov = this.getFov();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.geometry = new THREE.PlaneBufferGeometry(1, 1, 1, 1);

    this.allImages = this.getImages('img[data-hover]');
    this.figures = this.getFigures(this.allImages);

    window.addEventListener('resize', () => {
      this.resize();
    });

    window.addEventListener('scroll', () => {
      this.handleScroll();
    });

    document.addEventListener('keyup', () => {
      this.figures.forEach(figure => {
        figure.updateMesh();
      });
    });

    this.initCamera();
    this.initFigures();
    this.update();
  }

  getFigures(allImages) {
    const createdFigures = [];

    allImages.forEach(image => {
      createdFigures.push(new Figure(image, this.scene, this.geometry));
    });

    return createdFigures;
  }

  getImages(selector) {
    return document.querySelectorAll(selector);
  }

  initFigures() {
    this.figures.forEach(figure => {
      figure.start();
    });
  }

  getFov() {
    const fov =
      (180 * (2 * Math.atan(window.innerHeight / 2 / perspective))) / Math.PI;
    return fov;
  }

  initCamera() {
    this.camera = new THREE.PerspectiveCamera(
      this.fov,
      window.innerWidth / window.innerHeight,
      1,
      1000
    );

    this.camera.position.set(0, 0, perspective);
  }

  updateCamera() {
    this.fov = this.getFov();

    this.camera.fov = this.fov;
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
  }

  updateCanvas() {
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  }

  handleScroll() {
    this.scrollDistance = -window.pageYOffset;
  }

  resize() {
    this.scrollDistance = -window.pageYOffset;

    this.updateCanvas();
    this.updateCamera();
    this.figures.forEach(figure => {
      figure.updateMesh();
    });
  }

  update() {
    this.camera.position.y = this.scrollDistance;
    this.figures.forEach(figure => {
      figure.update();
    });

    this.renderer.render(this.scene, this.camera);
    requestAnimationFrame(() => {
      this.update();
    });
  }
}
